/* Lisa Kookt - desktopmenu: dropdowns (Alle categorieën, Kookboeken & Recepten)
   openen bij hover, met korte vertraging zodat langs bewegen niets opent.
   Klikken blijft werken (theme-gedrag). Alleen op desktop (>= 990px) en
   alleen als het apparaat echt een muis heeft. */
(function () {
  'use strict';
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;

  function hasMouse() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }
  function isDesktop() { return window.innerWidth >= 990; }

  /* Megamenu Kookboeken & Recepten (23-09-2026): de inhoud komt uit
     snippets/lk-mm-kookboeken.liquid (<template id="lk-mm-kook-tpl">) en
     vervangt de gewone lijst in de dropdown van het item naar /collections/kookboeken. */
  function buildKookMenu() {
    var tpl = document.getElementById('lk-mm-kook-tpl');
    if (!tpl) return;
    var links = document.querySelectorAll('.header__inline-menu details > summary a[href$="/collections/kookboeken"]');
    Array.prototype.forEach.call(links, function (a) {
      var details = a.closest('details');
      if (!details || details.dataset.lkKook) return;
      var panel = details.querySelector('.header__submenu');
      if (!panel) return;
      details.dataset.lkKook = '1';
      panel.className = 'lk-mega lk-mega--kook text color-background-1 gradient header__submenu list-menu list-menu--disclosure caption-large motion-reduce wbmenufull';
      panel.innerHTML = '';
      panel.appendChild(tpl.content.cloneNode(true));
    });
  }

  /* Mobiel menu (24-09-2026): header.liquid koppelt icoontjes aan de exacte
     menutitel. Rijen die geen icoon kregen (bijv. na hernoemen naar "Kookboeken"
     of "Nieuwste producten") krijgen er hier een op basis van de link. */
  var DRAWER_ICONS = {
    '/collections/kookboeken': '📖',
    '/collections/nieuw': '✨',
    '/blogs/recepten': '🍳'
  };
  function addDrawerIcons() {
    var rows = document.querySelectorAll('#menu-drawer .lk-row > a');
    Array.prototype.forEach.call(rows, function (a) {
      if (a.querySelector('.lk-ic')) return;
      var path = (a.getAttribute('href') || '').split('?')[0];
      var ic = DRAWER_ICONS[path];
      if (!ic) return;
      var s = document.createElement('span');
      s.className = 'lk-ic';
      s.textContent = ic;
      a.insertBefore(s, a.firstChild);
    });
  }

  /* Megamenu Alle categorieën (24-09-2026): de kolom "Inspiratie" komt onder
     "Bakken & zoet" te staan, zodat het menu een kolom smaller is. */
  function mergeInspiratie() {
    var panels = document.querySelectorAll('.header__inline-menu .lk-mega:not(.lk-mega--kook)');
    Array.prototype.forEach.call(panels, function (p) {
      if (p.dataset.lkMerged) return;
      var bak = null, insp = null;
      Array.prototype.forEach.call(p.querySelectorAll('.row > .col-3'), function (c) {
        var h = c.querySelector('.wbmenuinner > a');
        var t = h ? h.textContent.trim().toLowerCase() : '';
        if (t.indexOf('bakken') === 0) bak = c;
        if (t.indexOf('inspiratie') === 0) insp = c;
      });
      if (!bak || !insp) return;
      var inner = insp.querySelector('.wbmenuinner');
      if (!inner) return;
      inner.classList.add('lk-mm-stacked');
      bak.appendChild(inner);
      insp.parentNode.removeChild(insp);
      p.dataset.lkMerged = '1';
      p.classList.add('lk-mega--3col');
    });
  }

  function init() {
    addDrawerIcons();
    mergeInspiratie();
    buildKookMenu();
    if (!hasMouse()) return;
    var items = document.querySelectorAll('.header__inline-menu details');
    Array.prototype.forEach.call(items, function (details) {
      if (details.dataset.lkHover) return;
      details.dataset.lkHover = '1';
      var openT = null, closeT = null;
      var summary = details.querySelector('summary');

      function open() {
        clearTimeout(closeT);
        if (details.open) return;
        details.open = true;
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
      function close() {
        clearTimeout(openT);
        if (!details.open) return;
        details.open = false;
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      details.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeT);
        openT = setTimeout(open, OPEN_DELAY);
      });
      details.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        clearTimeout(openT);
        closeT = setTimeout(close, CLOSE_DELAY);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
